import React from "react";
import { SvgCommon } from ".";
import { IconModel } from "../../models";

export const UploadLinkIcon: React.FC<IconModel> = (props) => {
  return (
    <SvgCommon {...props}>
      <path d="M17.28 7.20023C23.6423 7.20023 28.8 12.3579 28.8 18.7202C28.8 25.0826 23.6423 30.2402 17.28 30.2402M17.28 7.20023C10.9177 7.20023 5.76001 12.3579 5.76001 18.7202C5.76001 25.0826 10.9177 30.2402 17.28 30.2402M17.28 7.20023C19.6659 7.20023 21.6 12.3579 21.6 18.7202C21.6 25.0826 19.6659 30.2402 17.28 30.2402M17.28 7.20023C14.8941 7.20023 12.96 12.3579 12.96 18.7202C12.96 25.0826 14.8941 30.2402 17.28 30.2402M5.76001 20.1602C13.012 16.5342 21.548 16.5342 28.8 20.1602" stroke={props.color} strokeWidth="2.16"/>
    </SvgCommon>
  );
};